import React from 'react'
import {BsPuzzleFill} from 'react-icons/bs'
import {FaTrophy} from 'react-icons/fa'
import {PiMedalFill} from 'react-icons/pi'

// Icon dùng cho EmptyHolder trong phạm vi Games — thay cho logo Kristo mặc định,
// đúng chủ đề trò chơi/thành tích. GamePuzzleEmptyIcon: nội dung/thư viện game
// (câu hỏi, danh sách game). GameTrophyEmptyIcon: lịch sử chơi cá nhân.
// GameLeaderboardEmptyIcon: bảng xếp hạng - thêm huy hiệu "1" gợi ý vị trí dẫn đầu còn trống.
const EmptyIconBadge = ({children}) => (
    <div
        className="flex flex-center rounded-full"
        style={{width: 72, height: 72, background: 'linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)'}}>
        {children}
    </div>
)

export const GamePuzzleEmptyIcon = () => (
    <EmptyIconBadge>
        <BsPuzzleFill size={30} className="text-purple-400"/>
    </EmptyIconBadge>
)

export const GameTrophyEmptyIcon = () => (
    <EmptyIconBadge>
        <FaTrophy size={30} className="text-purple-400"/>
    </EmptyIconBadge>
)

export const GameLeaderboardEmptyIcon = () => (
    <div className="relative w-fit mx-auto">
        <EmptyIconBadge>
            <PiMedalFill size={32} className="text-amber-400"/>
        </EmptyIconBadge>

    </div>
)
